<template>
  <div id="loginPage">
    <div style="display: flex; height: 100vh;">
      <div id="loginContainer" style="width: 400px; margin-left: auto; margin-right: auto; align-items: center;">
        <div :class="{ failure: failure }" ref="loginCard">
          <div class="card bordernone bs-small" style="margin-top: 200px;">
            <div class="card-header bggreen text-white" style="padding: 20px 1.25rem;">
              <div style="display: flex;">
                <img
                  class="mw100"
                  src="@/assets/img/cube.png"
                  style="max-width: 30px; max-height: 30px"
                />
                <h4 class="mb0 ml10">Reset My Password</h4>
              </div>
            </div>
            <div class="card-body" ref="cardBody">
              <div v-if="!unsupported">
                <h6 v-if="noMatch" style="color: #e25353">
                  The passwords do not match.
                </h6>
                <form @submit.prevent="resetPW">
                  <small v-if="usedEmail" style="color: #6f6e6e">
                    There is an issue with your username
                  </small>
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      type="email"
                      v-model="email"
                      placeholder="Email Address"
                      name="email"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span class="material-icons" style="font-size: 20px; color: #777373;">
                        mail
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      type="text"
                      v-model="code"
                      placeholder="Reset Code"
                      name="resetCode"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span class="material-icons" style="font-size: 20px; color: #777373;">
                        key
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      :type="showPW ? 'text' : 'password'"
                      v-model="password1"
                      name="password1"
                      placeholder="New Password"
                      autocomplete="new-password"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span v-show="showPW" @click="hidePassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
visibility_off
</span>
                        </span>
                        <span v-show="!showPW" @click="showPassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
                    visibility
                    </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      :type="showPW ? 'text' : 'password'"
                      v-model="password2"
                      name="password2"
                      placeholder="New Password Confirmation"
                      autocomplete="new-password"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span v-show="showPW" @click="hidePassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
visibility_off
</span>
                        </span>
                        <span v-show="!showPW" @click="showPassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
                    visibility
                    </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="form-group mt-4">
                    <button
                      v-if="maintenanceMode || locked"
                      disabled
                      class="loginbtn"
                      style="width: 70.05px; height: 34px"
                    >
                      <span v-if="!sending">Reset</span>
                      <span v-else>
                        <looping-rhombuses-spinner
                          :animation-duration="1000"
                          :rhombus-size="6"
                          color="#fff"
                        />
                      </span>
                    </button>
                    <button
                      v-else
                      class="loginbtn"
                      style="width: 70.05px; height: 34px"
                      @click.prevent="resetPW"
                    >
                      <span v-if="!sending">Reset</span>
                      <span v-else>
                        <looping-rhombuses-spinner
                          :animation-duration="1000"
                          :rhombus-size="6"
                          color="#fff"
                        />
                      </span>
                    </button>
                  </div>
                  <p style="text-align: left;">
                    <router-link to="/" class="login-link">
                      <small>Back to Login</small>
                    </router-link>
                  </p>
                </form>
              </div>
              <!-- Unsupported Browser -->
              <div v-else>
                <h6>
                  It looks like you are using an outdated web browser. In order to have a consistent experience, we suggest using a safer browser that follows current web standards. Here are a few good options!
                </h6>
                <hr />
                <ul class="browser-list" style="display: flex; justify-content: space-around; padding: 0; list-style: none;">
                  <li>
                    <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
                      <img
                        class="mw100"
                        src="@/assets/img/chrome.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Google Chrome"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" rel="noopener noreferrer">
                      <img
                        class="mw100"
                        src="@/assets/img/firefox.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Mozilla Firefox"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noopener noreferrer">
                      <img
                        class="mw100"
                        src="@/assets/img/edge.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Microsoft Edge"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/en_AU/downloads/safari" target="_blank" rel="noopener noreferrer">
                      <img
                        class="mw100"
                        src="@/assets/img/safari.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Apple Safari"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
         
        </div>
         <!-- Password Hints -->
         <div v-if="passwordValidation.errors.length > 0" class="hints" ref="hints">
            <h4 style="margin-top: 0;">Password Requirements</h4>
            <p v-for="error in passwordValidation.errors" :key="error">{{ error }}</p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { gsap } from 'gsap';
// import VueRecaptcha from "vue-recaptcha";

//import shared from '@/state';

export default {
  name: "Reset",
  components: {
    LoopingRhombusesSpinner,
    // "vue-recaptcha": VueRecaptcha,
  },
  data() {
    return {
      url: import.meta.env.VUE_APP_URL,
      title: import.meta.env.VUE_APP_TITLE,
      email: this.$route.query.email ? this.$route.query.email : '',
      code: this.$route.query.code ? this.$route.query.code : '',
      password1: "",
      password2: "",
      failure: false,
      noMatch: false,
      error: null,
      feedback: "",
      errors: [],
      sending: false,
      maintenanceMode: false,
      locked: false,
      unsupported: false,
      userIP: "",
      robot: false,
      usedEmail: false,
      showPW: false,
      rules: [
				{ message:'One lowercase letter required.', regex:/[a-z]+/ },
				{ message:"One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message:"8 characters minimum.", regex:/.{8,}/ },
				{ message:"One number required.", regex:/[0-9]+/ }
			],
    };
  },

  methods: {
    animateLoginCard() {
      const tl = gsap.timeline();

      tl.from(this.$refs.loginCard, {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power2.out',
      })
        .from(
          this.$refs.cardHeader,
          {
            duration: 1,
            opacity: 0,
            x: 0,
            ease: 'power1.out',
          },
        )
       
    },
    animateRecaptcha() {
      gsap.from(this.$refs.recaptchaGroup, {
        duration: 0.8, // Smooth fade duration
        opacity: 0,
        ease: 'power1.out',
      },'-=0.1');
    },
    animateFailure() {
      gsap.to(this.$refs.loginCard, {
        duration: 0.2,
        x: -10,
        repeat: 3,
        yoyo: true, // Back and forth
        ease: 'power1.inOut',
        onComplete: () => gsap.set(this.$refs.loginCard, { x: 0 }), // Reset position
      });
    },
    refreshPage: function () {
      //this.$router.go();
      //refresh to get the newest update
      // this.$forceUpdate();
    },
    checkUserLock: function () {
      //console.log("Check to see of the user is locked");
    },
    showPassWord: function () {
      this.showPW = true;
    },
    hidePassWord: function () {
      this.showPW = false;
    },
    /*
    resetPW({ commit }, postData) {
			//console.log("in Vuex");
			let axiosConfig = {
				headers: {
					"Content-Type": "application/json;charset=UTF-8",
				},
			};
			return axios
				.post(`${process.env.VUE_APP_SERVER_URL}/api/v1/reset-password`, postData, axiosConfig)
				.then((response) => {
					console.log(response);
					if (response.data.type == 'success') {
						return true;
					} else {
						Vue.noty.error("There was an issue updating your password. Please check the security code that has a duration of 20 minutes.");
						return false;
						
					}
				})
				.catch((err) => {
					console.log(err);
					Vue.noty.error("There was an issue updating your password. Please check the security code that has a duration of 20 minutes.");
					return false;
				});
		},
    */

    resetPW(){
      console.log("submitted")
      if (!this.email.length) {
          // this.$noty.error("Please enter your email");
          this.$toast.error("Please enter your email", {
                hideProgressBar: false,
                icon: false,
          });
          this.failure = true;
      } else if (!this.code.length) {
          // this.$noty.error("Please enter the security code from your email.");
          this.$toast.error("Please enter the security code from your email.", {
                hideProgressBar: false,
                icon: false,
            });
          this.failure = true;
      } else if (this.password1 !== this.password2) {
          // this.$noty.error("Passwords do not match");
          this.$toast.error("Passwords do not match", {
                hideProgressBar: false,
                icon: false,
            });
            this.failure = true;
      } else if (!this.password1.length || !this.password2.length ) {
          // this.$noty.error("Please enter a new password");
          this.$toast.error("Please enter a new password", {
                hideProgressBar: false,
                icon: false,
            });
            this.failure = true;
      }  else if (this.passwordValidation.errors.length ) {
          // this.$noty.error("Password requirements are not met.");
          this.$toast.error("Password requirements are not met.", {
                hideProgressBar: false,
                icon: false,
          });
          this.failure = true;
      }  else {      

        let postData = {
          emailAddress: this.email.trim(),
          securityCode: this.code.trim(),
          password: this.password1.trim(),
          confirmPassword: this.password2.trim(),
        };

        console.log(postData)

        let axiosConfig = {
				headers: {
					"Content-Type": "application/json;charset=UTF-8",
				},
			};
			return axios
				.post(`${import.meta.env.VITE_APP_SERVER_URL}/api/v1/reset-password`, postData, axiosConfig)
				.then((response) => {
					console.log(response);
					if (response.data.type == 'success') {
            this.$toast.success("Your password has been updated");
            this.$router.push("/");
						return true;
					} else {
            this.$toast.error("There was an issue updating your password. Please check the security code that has a duration of 20 minutes.");
						// Vue.noty.error("There was an issue updating your password. Please check the security code that has a duration of 20 minutes.");
						return false;
						
					}
				})
				.catch((err) => {
					// console.log(err);
					this.$toast.error("There seems to be an issue with your credentials.", {
                hideProgressBar: false,
                icon: false,
            });

          console.log("error " + err);
					return false;
				});

      }
    },
    activationGen(){
      return crypto.randomBytes(3, function(err, buffer) {
        parseInt(buffer.toString('hex'), 16).toString().substr(0,6);
      }).toString();
    },
    login() {
      localStorage.removeItem("SSCUSER");
      const check = this.checkEmail(this.username);

      //console.log(check);

      if (check == true) {
        this.usedEmail = true;
        //console.log("is an email");
      } else {
        this.usedEmail = false;
        //console.log("not an email");
      }

      if (this.robot && check == false) {
        //console.log("in here");
        this.sending = true;
        var postData = {
          username: this.username,
          password: this.password,
          ip: this.userIP,
        };

        this.$store
          .dispatch("login", postData)
          .then((response) => {
            //console.log("Response " + response);
            //this.$router.push("/home");
            //next({ name: "Login", query: { from: loginpath } });
            if (response) {
              if (this.$route.query.from) {
                //console.log("has query");
                this.$router.push({ path: this.$route.query.from });
              } else {
                //console.log("has no query");
                this.$router.push({ path: "/home" });
              }
              commit("SET_TOKEN", localStorage.getItem("SSCUSER"));
              //this.$router.push("/home");
              this.sending = false;
            } else {
              this.sending = false;
            }
          })
          .catch((err) => {
            //console.log("error " + err);
            this.sending = false;
            /*
            this.$noty.error(
              "There seems to be an issue with your credentials."
            );
            */
            //this.feedback = "There seems to be an issue with your credentials.";
          });

        /*
        this.$store.commit('showNavigation');
        localStorage.setItem('sscuser', user);
        localStorage.setItem('isLoggedIn', '1');

        this.$router.push({
          name: 'Images',
        });
        */
      }
    },

    onVerify: function (response) {
      if (response) this.robot = true;
    },

    showNavigation() {
      this.$store.commit("showNavigation");
    },

    hideNavigation() {
      this.$store.commit("hideNavigation");
    },

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    checkEmail(emailAddress) {
      var sQtext = "[^\\x0d\\x22\\x5c\\x80-\\xff]";
      var sDtext = "[^\\x0d\\x5b-\\x5d\\x80-\\xff]";
      var sAtom =
        "[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+";
      var sQuotedPair = "\\x5c[\\x00-\\x7f]";
      var sDomainLiteral = "\\x5b(" + sDtext + "|" + sQuotedPair + ")*\\x5d";
      var sQuotedString = "\\x22(" + sQtext + "|" + sQuotedPair + ")*\\x22";
      var sDomain_ref = sAtom;
      var sSubDomain = "(" + sDomain_ref + "|" + sDomainLiteral + ")";
      var sWord = "(" + sAtom + "|" + sQuotedString + ")";
      var sDomain = sSubDomain + "(\\x2e" + sSubDomain + ")*";
      var sLocalPart = sWord + "(\\x2e" + sWord + ")*";
      var sAddrSpec = sLocalPart + "\\x40" + sDomain; // complete RFC822 email address spec
      var sValidEmail = "^" + sAddrSpec + "$"; // as whole string

      var reValidEmail = new RegExp(sValidEmail);

      return reValidEmail.test(emailAddress);
    },
    detectIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      //if (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) {
      if (msie > 0 || msie == 11) {
        // If Internet Explorer, return version number
        //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
        this.unsupported = true;
      } // If another browser, return 0
      else {
        // alert("otherbrowser");
        return;
      }

      return false;
    },
  },

  computed: {
    //returns if the nav is open or closed
    navigationState() {
      return this.$store.state.nav;
    },
    notSamePasswords () {
			if (this.passwordsFilled) {
				return (this.password1 !== this.password2)
			} else {
				return false
			}
		},
		passwordsFilled () {
			return (this.password1 !== '' && this.password2 !== '')
		},
    passwordValidation () {
			let errors = []
			for (let condition of this.rules) {
				if (!condition.regex.test(this.password1)) {
					errors.push(condition.message)
				}
			}
			if (errors.length === 0) {
				return { valid:true, errors }
			} else {
				return { valid:false, errors }
			}
		}
  },
  watch: {
    failure(newVal) {
      if (newVal) this.animateFailure();
    },
  },
  mounted() {
    this.animateLoginCard();
  },

  created() {
    this.refreshPage();
    localStorage.removeItem("SSCUSER");
    this.$store.commit("hideNavigation");
    this.toggleBodyClass("removeClass", "wsactive");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("SSCUSER");
    this.detectIE();
    //console.log(this.$router);
    console.log(this.$route.query.from);
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.userIP = ip;
      });
    //console.log(window.innerWidth);
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.card-header {
  display: flex;
  display: flex;
  align-items: center;
}

.login {
  display: none;
}
.mt200 {
  margin-top: 200px;
}
.bggreen {
  background: #00b4b4;
}
.green {
  color: #00b4b4;
}
.bordernone {
  border: none;
}
.mt15 {
  margin-top: 15px;
}

.bs {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.card-header {
  border-bottom: none;
}
.loginbtn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  background: #00b4b4;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 15px;
}
.mb0 {
  margin-bottom: 0 !important;
}

.ml10 {
  margin-left: 10px;
}
.login-link {
  cursor: pointer;
  color: #00b4b4;
  line-height: 1;
}

#loginPage {
  height: 100vh !important;
  width: 100vw !important;
}


.browser-list {
  list-style-type: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: scale;
}

.browser-list li {
  padding: 5px;
  transition: all 0.2s ease-in-out;
}
.browser-list li:hover {
  transform: scale(1.1);
}
.browser-list li:active {
  transform: scale(1.1);
}
.password-icon {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.password-icon:hover {
  color: #00b4b4;
}
.password-icon:active {
  color: #00b4b4;
}

.form-control:focus {
    border-color: #00b4b4;
}
.hints {
  max-width: 400px;
  padding: 1em;
  background: #00b4b4;
  margin: 1em 0;
  font-size: 0.9em;
  color: #fff;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 4px !important;
  text-align: left;
}
.hints h2 {
  margin-top:  0;
}
.hints p {
  margin: 0;
}
.hints p::before {
  content: ">";
  font-size: 0.9em;
  margin-right: 6px;
  display: inline-block;
}
.hint-enter {
  opacity: 0;
  transform: translate3d(-20px, 0, 0);
}
.hint-leave-to {
  opacity: 0;
  transform: translate3d(0, 20px, 0);
}
.hint-enter-active {
  transition: 300ms;
}
.hint-leave-active {
  transition: 400ms;
}
#loginPage {
  height: 100vh !important;
  width: 100vw !important;
   /*background-image: linear-gradient(45deg, rgba(66,66,66, 0.96), rgba(8,83,156, 0.45)), url('SpaceSaver-0041.jpeg');*/
    
    width: 100%;
    background-size: cover;
    text-align: center;
    background-position: center;
    color: #fff;
    background-color: #DDE3EA;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cg stroke='%23D8DEE5' stroke-width='0' stroke-miterlimit='99' %3E%3Cpolygon fill='%23E2E8F0' points='-70 85 100 0 0 150 200 0 0 300 350 0 0 500 550 0 0 750 800 0 0 1050 1100 0 0 1400 1450 0 0 1850 1950 0 1000 3000 -99 3000'/%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
}
@media (max-width: 399px) {
  #loginContainer {
    width: 90%;
  }
}
@media (min-width: 400px) {
  #loginContainer {
    width: 400px;
  }
}
/* Default Bootstrap input styling (optional, for reference) */
.form-control {
  border: 1px solid #ced4da; /* Bootstrap’s default border */
}

/* Remove focus outline and prevent border darkening */
.form-control:focus {
  outline: none !important; /* No outline */
  box-shadow: none !important; /* No Bootstrap glow */
  -webkit-box-shadow: none !important; /* No Chrome glow */
  border-color: #ced4da !important; /* Lock to Bootstrap’s default border color */
}

/* Handle autofill: no outline, no glow, no blue background */
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover,
.form-control:-webkit-autofill:focus,
.form-control:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #fff inset !important; /* Force white background */
  box-shadow: none !important; /* No glow */
  outline: none !important; /* No outline */
  border-color: #ced4da !important; /* Match Bootstrap’s default border */
  -webkit-text-fill-color: #495057 !important; /* Match Bootstrap’s text color */
}

/* Disabled inputs */
.form-control:disabled,
.form-control:disabled:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ced4da !important; /* Keep default border */
  background-color: #e9ecef !important; /* Bootstrap’s disabled bg */
}
</style>
